import {
  PanelSection,
  Stack,
  Heading,
  Paragraph,
  PanelFooter,
  PanelActions,
  Button,
  Banner,
} from '@customerio/pluma-components/react';
import { useSafeNavigate } from '@/services/router/safe-navigate';
import { AuthLayout } from './layout';
import type { AuthError } from '@/features/mcp/types';
import { getErrorMessage } from '@/utils/mcp';

interface ErrorViewProps {
  error: AuthError;
}

export const ErrorView = ({ error }: ErrorViewProps) => {
  const safeNavigate = useSafeNavigate();

  return (
    <AuthLayout>
      <PanelSection>
        <Stack gap="200" alignBlock="center" alignInline="center">
          <Heading level="3">Configuration Error</Heading>
          <Paragraph>
            This application cannot be connected to Customer.io due to invalid or missing configuration parameters.
          </Paragraph>
          <Banner variant="error" title="Configuration Error">
            {getErrorMessage(error)}
          </Banner>
        </Stack>
      </PanelSection>
      <PanelFooter withBorder>
        <PanelActions>
          <Button variant="primary" onClick={() => safeNavigate('/')}>
            Return to Customer.io
          </Button>
        </PanelActions>
      </PanelFooter>
    </AuthLayout>
  );
};
